import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { COLOR_PURPLE } from 'styles/variables/colors';
import HeaderInformationMobile from '../HeaderInformationMobile';
import { useStyles } from './styles';
import LazyLoad from 'react-lazyload';
import Image from 'next/image';
import InstitutionsCommunicationMobile from 'components/InstitutionsCommunicationMobile';
import CustomLandingPageMobile from 'components/CustomLandingPageMobile';
import BookDemoMobile from 'components/BookDemoMobile';
import PublishedSectionMobile from 'components/PublishedSectionMobile';
import ReferToAcademicInstitutionMobile from 'components/ReferToAcademicInstitutionMobile';
import CreatingScienceIllustrationsMobile from 'components/CreatingScienceIllustrationsMobile';

export default function MedicalContentMobile() {
  const classes = useStyles();

  return (
    <>
      <Box py={1} bgcolor={COLOR_PURPLE} height={230}>
        <Container>
          <HeaderInformationMobile
            marginLeftPercentage={88}
            textTitle="For Medical Associations"
            textDescription="Get in touch with our team to offer the best science infographic maker for your associates."
          />
        </Container>
      </Box>

      <InstitutionsCommunicationMobile
        textTitle={
          <>
            The best infographic maker for <br /> scientific communication
          </>
        }
        textInformation={
          <>
            Trustworthy professionals require a certain level of accuracy when <br />
            communicating their work for the scientific community. Browse through
            <br />
            75,000+ scientifically-accurate illustrations in more than 80 study fields.
          </>
        }
        textButton="Request a Demonstration"
      />

      <CustomLandingPageMobile
        textTitle={
          <>
            Custom landing page <br /> with email authentication
          </>
        }
        textDescription={
          <>
            Use the association's visual identity to <br />
            <b>strengthen the brand experience</b> while <br />
            protecting user data. Through domain-
            <br />
            based authentication and an assigned <br />
            account manager,{' '}
            <b>
              all users can log in
              <br />
              using their email
            </b>{' '}
            linked with the <br />
            association.
          </>
        }
        textButton="Get a Custom Experience"
      />

      <LazyLoad offset={100}>
        <Container>
          <Box py={3}>
            <Typography className={classes.title} component="h2">
              <b>
                Mind the Graph's trusted by researchers and professionals <br /> from 100+
                corporations worldwide
              </b>
            </Typography>

            <Box className={classes.mainBoxImages} pt={2}>
              <Image
                src="/images/logos-academics-institutions/stanford-university-icon.png"
                alt="stanford icon"
                loading="lazy"
                width={69}
                height={31}
              />

              <Image
                src="/images/logos-academics-institutions/pearson-icon.png"
                alt="pearson icon"
                loading="lazy"
                width={75}
                height={53}
              />

              <Image
                src="/images/logos-academics-institutions/abbott-icon.png"
                alt="abbott icon"
                loading="lazy"
                width={94}
                height={71}
              />

              <Image
                src="/images/ico_harvard.png"
                alt="harvard icon"
                loading="lazy"
                width={58}
                height={59}
              />
            </Box>
            <Box className={classes.mainBoxImages} pt={1}>
              <Image
                src="/images/logos-academics-institutions/ucla-health-icon.png"
                alt="ucla icon"
                loading="lazy"
                width={118}
                height={25}
              />

              <Image
                src="/images/logos-academics-institutions/mcgill-icon.png"
                alt="mcgill icon"
                loading="lazy"
                width={107}
                height={25}
              />
            </Box>
          </Box>
        </Container>
      </LazyLoad>

      <BookDemoMobile />

      <PublishedSectionMobile titlePublished="Mind the Graph has been cited in many journals worldwide" />

      <Box bgcolor="#EEEEEE" py={6}>
        <CreatingScienceIllustrationsMobile textTitle="A perfect tool for students creating science illustrations" />
      </Box>

      <ReferToAcademicInstitutionMobile
        textTitle="Refer Mind the Graph to your Scientific Society"
        textSubtitle={
          <>
            Refer the best science infographic maker as <br />
            an exclusive benefit to all associates
          </>
        }
        textInformation={
          <>
            Insert the person in charge's email <br />
            below and we'll get in touch
          </>
        }
      />
    </>
  );
}
